export const FEEDBACK_TELEGRAM_LINK = "https://t.me/+78EC_YKwcH01MGJh";

export const CODERHOUSE_LINK =
  "https://www.coderhouse.com/?utm_source=codealo&utm_medium=alianzas&utm_campaign=plataforma";
